import { globalConfig } from '@/global-config'

export const JWT_ACCESS_TOKEN_KEY = `${globalConfig.appName}-jwt-access-token`
